import React, { useState } from "react";

import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';

import SectionTitle from "@app/components/3_modules/sections/SectionTitle";
import InputSiren from "@app/components/2_widgets/inputs/InputSiren";
import DataPrevInputEdit from "@app/components/2_widgets/dossiers/DataPrevInputEdit";
import DataPrevAddressInputs from "@app/components/2_widgets/dossiers/DataPrevAddressInputs";

import { buildCustomerFormDataBuilder } from "@app/utils/form_data_builders/CustomerFormDataBuilder";
import { useCustomer, useCustomerDispatch, CUSTOMER_ACTIONS } from "@app/contexts/CustomerContext";
import { useDossier, useDossierDispatch, DOSSIER_ACTIONS } from "@app/contexts/DossierContext";
import { buildDossierFormDataBuilder } from "@app/utils/form_data_builders/DossierFormDataBuilder";
import { useToast } from '@app/components/3_modules/ToastContainer';
import { useTranslation } from "react-i18next";


import { ChevronUp, ChevronDown } from "lucide-react";

export default function SectionDataPreview({}) {
    const [displaying, setDisplaying] = useState(true);    

    const auth = useAuth();
    const customer = useCustomer();
    const dossier = useDossier();

    const customerDispatch = useCustomerDispatch();
    const dossierDispatch = useDossierDispatch();

    const toast = useToast(); 
    const { t } = useTranslation();

    if (!customer && !dossier)
        return;    

    function displayInputSiren() {
        if (!customer.siren)
            return (
                <InputSiren callback={updateCustomer} label="Ajouter le SIREN car il est manquant" buttonLabel="Ajouter" />
            )        
    }

    function showCompanyData() {
        const structure = customer?.structures[0];

        return (
            <>
                <DataPrevInputEdit 
                    label="Nom ou dénomination" 
                    defaultValue={customer.company_name} 
                    formKey="company_name" 
                    placeholder="Renseigner le Nom de l'entreprise"
                />
                <div className="gray-line mb-2 mt-2"></div>

                <DataPrevInputEdit 
                    label="Nom commerciale" 
                    defaultValue={customer.trade_name} 
                    formKey="trade_name" 
                    placeholder="Renseigner le Nom Commerciale"
                />
                <div className="gray-line mb-2 mt-2"></div>

                <DataPrevAddressInputs />


                <DataPrevInputEdit 
                    label="SIREN" 
                    defaultValue={customer.siren} 
                    formKey="siren" 
                    placeholder="Renseigner le SIREN"
                />
                <div className="gray-line mb-2 mt-2"></div>

                <div className="row">
                    <div className="col-2 gray-text">SIRET</div>
                    <div className="col-6"><span className="editable-none">{structure?.siret}</span></div>
                </div>
                <div className="gray-line mb-2 mt-2"></div>

                <DataPrevInputEdit 
                    label="Code APE" 
                    defaultValue={customer.ape_code} 
                    formKey="ape_code" 
                    placeholder="Renseigner le code APE"
                />
                <div className="gray-line mb-5 mt-2"></div>

                {displayInputSiren()}
            </>        
        )
    }

    function updateCustomer(searched) {
        customer.siren = searched.siren;
        customer.ape_code = searched.ape_code;
        
        // Add new structures if none
        if (customer.structures?.length == 0) {
            customer.structures = searched.structures;
        }

        const formData = buildCustomerFormDataBuilder(customer);

        apiCall({
            method: "patch",
            path: `/api/v1/customers/${customer.id}`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                let data = response.data.customer;

                customerDispatch({
                    type: CUSTOMER_ACTIONS.UPDATE_ALL,
                    payload: data
                });

                if (dossier.structure_datas?.length == 0) {}
                    updateDossier(data);
            },
            onError: (error) => {
                error.response.data.messages.forEach(message => {
                    toast.addToast(
                        "Erreur",
                        t(message)                  
                    );
                });
            }
        });
    }

    function updateDossier(customer) {
        dossier.structure_datas = [];

        // Add structure_datas to dossier        
        customer.structures.forEach((st) => {
            let structure_data = {structure_id: null};

            structure_data.structure_id = st.id;
            
            dossier.structure_datas.push(structure_data);
        })
        
        const formData = buildDossierFormDataBuilder(dossier);
        
        apiCall ({
            method: "patch",
            path: `/api/v1/dossiers/${dossier.id}`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                dossierDispatch({
                    type: DOSSIER_ACTIONS.UPDATE_ALL,
                    payload: response.data.dossier
                });
            }
        });
    }    

    if (!dossier)
        return;

    function displayContent() {
        if (!displaying)
            return;

        return (
            showCompanyData()           
        )    
    }  

    return (
        <div className="page-section">
            <SectionTitle                
                title="Data Preview"
                onClick={() => setDisplaying(!displaying)}
                rightIcon={displaying ? <ChevronUp /> : <ChevronDown />}
            />
            {displayContent()}
        </div>
    )
}